/** Genre → CSS custom-property name (defined in tokens.css). */
export const genreTokens = {
  sports: "--g-sports",
  news: "--g-news",
  movies: "--g-movies",
  series: "--g-series",
  kids: "--g-kids",
  documentary: "--g-docs",
  music: "--g-music",
  other: "--g-other",
} as const;

export type GenreToken = keyof typeof genreTokens;

/** Map a normalized EPG genre string to its color token name. */
export function genreTokenFor(genre: string | undefined): GenreToken {
  const value = (genre ?? "").toLowerCase().trim();
  if (value.includes("sport")) return "sports";
  if (value.includes("news")) return "news";
  if (value.includes("movie") || value.includes("film")) return "movies";
  if (value.includes("series") || value.includes("drama")) return "series";
  if (value.includes("kid") || value.includes("children") || value.includes("family")) return "kids";
  if (value.includes("document") || value.includes("docu")) return "documentary";
  if (value.includes("music")) return "music";
  return "other";
}

/** Join truthy class names (tiny `clsx`). */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
